// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item.date-time-range .el-input__inner[data-v-0d028a8a] {\n  width: 46em;\n}", ""]);
// Exports
module.exports = exports;
